import { agents, agentsSection } from '@/content/site'

import { Reveal } from './shared/Reveal'
import { SplitTitle } from './shared/SplitTitle'

export function AgentsSection() {
  return (
    <section id="agents" className="py-16 md:py-24">
      <div className="shell">
        <Reveal>
          <p className="eyebrow">{agentsSection.eyebrow}</p>
        </Reveal>

        <h2 className="max-w-2xl font-sans text-[1.6rem] md:text-[2.15rem] font-bold tracking-[-0.02em] leading-[1.16]">
          <SplitTitle text={agentsSection.title} />
        </h2>

        <Reveal i={1}>
          <p className="mt-5 max-w-[46rem] text-[0.95rem] md:text-[1.05rem] leading-[1.75] text-ink-dim">
            {agentsSection.intro}
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-3">
          {agents.map((agent, i) => (
            <Reveal key={agent.name} i={i} className="h-full">
              <article className="group flex h-full flex-col bg-bg p-5 transition-colors hover:bg-accent/5 md:p-6">
                <div className="flex items-baseline justify-between gap-3">
                  <h3 className="font-sans text-base font-bold tracking-tight md:text-lg">
                    {agent.name}
                  </h3>
                  <span className="font-mono text-[0.63rem] uppercase tracking-[0.18em] text-accent/70">
                    {agent.verb}
                  </span>
                </div>
                <p className="mt-3 font-paragraph text-xs leading-relaxed text-ink-dim md:text-[0.82rem]">
                  {agent.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
